import { render, staticRenderFns } from "./LiquorWord.vue?vue&type=template&id=2d9a87f6&"
import script from "./LiquorWord.vue?vue&type=script&lang=js&"
export * from "./LiquorWord.vue?vue&type=script&lang=js&"
import style0 from "./LiquorWord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports